export const tablerow = (text: string) => `<tr>${text}</tr>`
